import { TFunction } from 'i18next';

import { setDefaultFavicon, setTitle } from '../../metadata';

/**
 * Sets the default title for the meeting room
 */
export function setDefaultMeetingRoomTitle(t: TFunction) {
  setTitle(t('telehealth-core:meta.meetingRoom'));
}

/**
 * Sets the default favicon and title for the meeting room
 */
export function setDefaultMeetingRoomFaviconAndTitle(t: TFunction) {
  setDefaultFavicon();
  setDefaultMeetingRoomTitle(t);
}
